var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 66,
    viewBox: "0 0 57 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6024 0H40.6975L56.9407 16.5407V61.4031C56.9407 63.9615 54.8583 65.9845 52.3593 65.9845H11.6024C9.04397 65.9845 7.021 63.9615 7.021 61.4031V4.64093C7.021 2.08247 9.04397 0 11.6024 0Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9407 16.5407H44.8624C42.5419 16.5407 40.6379 14.6368 40.6379 12.3163V0H40.6974L56.9407 16.5407Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9406 16.5408V28.6786L45.0408 16.5408H56.9406Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7548 31H2.43946C1.09218 31 0 32.0389 0 33.3205V52.7767C0 54.0582 1.09218 55.0971 2.43946 55.0971H45.7548C47.1021 55.0971 48.1943 54.0582 48.1943 52.7767V33.3205C48.1943 32.0389 47.1021 31 45.7548 31Z",
    fill: "#9A50A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4822 38.0469V48H32.4382V38.0469H34.4822ZM37.5447 38.0469V39.6533H29.4236V38.0469H37.5447Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6338 38.0469L24.5068 41.5195L26.3799 38.0469H28.7246L25.833 42.9824L28.7998 48H26.4346L24.5068 44.459L22.5791 48H20.2002L23.1738 42.9824L20.2754 38.0469H22.6338Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5139 38.0469V48H14.47V38.0469H16.5139ZM19.5764 38.0469V39.6533H11.4553V38.0469H19.5764Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1944 52.7757V55.0367C48.1944 56.3456 47.1234 57.3571 45.8144 57.3571H7.021V55.0962H45.8144C47.1234 55.0962 48.1944 54.0252 48.1944 52.7757Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/TXT.a4e6625ff1f92e327985ec4513ac1b6d.svg";
export { ForwardRef as ReactComponent };